//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  name: 'contactForm',
  data() {
    return {
      terms: false,
      filter: {
        form: 'contact',
        from_email: '',
        from_name: '',
        reply_to_user: true,
        return_url: '/bedankt',
        content: {
          name: '',
          email: '',
          message: '',
          subject: '',
        },
      },
    }
  },
  computed: {
    ...mapState({
      formStatus: ({ formStore: {formStatus} }) => formStatus,
    }),
  },
  methods: {
    processForm: function() {
      var error = {};
      if (!this.filter.content.name) {
        error.type = 'name';
        error.text = 'Je hebt je naam niet ingevuld';
        this.$store.commit('formStore/updateErrors', error);
      } else {
        this.filter.from_name = this.filter.content.name;
      }

      if (!this.filter.content.email) {
        error.type = 'email';
        error.text = 'Je emailadres is ongeldig';
        this.$store.commit('formStore/updateErrors', error);
      } else {
        this.filter.from_email = this.filter.content.email;
      }

      if (!this.filter.content.subject) {
        error.type = 'subject';
        error.text = 'Je hebt geen onderwerp ingevuld';
        this.$store.commit('formStore/updateErrors', error);
      }

      if (!this.filter.content.message) {
        error.type = 'message';
        error.text = 'Je hebt geen bericht ingevuld';
        this.$store.commit('formStore/updateErrors', error);
      }
      if (!this.terms) {
        error.type = 'terms';
        error.text = 'Je moet akkoord gaan met de algemene voorwaarden en de geldende privacy verklaring';
        this.$store.commit('formStore/updateErrors', error);
      }

      let form = document.getElementById('contact');
      var formData = new FormData(form);
      formData.append('form', this.filter.form); 
      formData.append('from_email', this.filter.from_email); 
      formData.append('from_name', this.filter.from_name); 
      formData.append('reply_to_user', this.filter.reply_to_user); 
      formData.append('return_url', this.filter.return_url); 
      formData.delete('terms'); 
      if (Object.keys(this.formStatus.errors).length === 0) {
        this.$store.dispatch('formStore/sendForm', formData);
      } else {
        this.goto('contact');
        var notificationObj = {};
        notificationObj.type = 'error';
        notificationObj.message = 'Je formulier is niet verzonden. Vul ook de rood gekleurde velden in.';
        this.$store.commit('notificationStore/setNotification', notificationObj);  
        this.$forceUpdate();
      }
    },
  }
}
